
let styles = {
    container: {
      padding: '3%',
      display: 'flex',
      justifyContent: 'center',
    },

    table: {
        backgroundColor: '#dcdcdc',
        padding: '1%',
      },

    main_header: {
        padding: '1%',
        marginBottom: '3%',
        textAlign:'center',
        fontSize:'120%'
    },

    items: {
        padding: '1%',
        
    },

    item_body: {
        padding: '6px ',
        textAlign:'center',
        width:'40%'
      },

    input: {
        width: '40%',
    },
    
    item_header: {
        fontWeight: 600,
        paddingLeft: '5%',
        width:'50%'
    },

    button_submit: {
        padding: '1%',
        justifyContent: 'center',
        display: 'flex',
        paddingTop: '6%',
    },

    check_list: {
        clear: 'both',
    },
    item_table: {
        backgroundColor: '#dcdcdc',
        padding: '1%',
        paddingTop: '6%',
      },


  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/venueRent/style.js